"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.companyappAutoListApi = companyappAutoListApi;
exports.prizeDrawConfigList = prizeDrawConfigList;
exports.prizeDrawDelete = prizeDrawDelete;
exports.prizeDrawGetInfo = prizeDrawGetInfo;
exports.prizeDrawNewList = prizeDrawNewList;
exports.prizeDrawNewUpdate = prizeDrawNewUpdate;
exports.prizeDrawOpen = prizeDrawOpen;
exports.saveOrUpdate = saveOrUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 列表分页
 */
function prizeDrawConfigList(params) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/config/list',
    method: 'GET',
    params: params
  });
}

/**
 * 删除
 */
function prizeDrawDelete(params) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/config/delete',
    method: 'GET',
    params: params
  });
}

/**
 * 获取开奖信息
 */
function prizeDrawGetInfo(params) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/config/getInfo',
    method: 'GET',
    params: params
  });
}

/**
 *新增更新抽奖配置
 */
function saveOrUpdate(data) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/config/saveOrUpdate',
    method: 'post',
    data: data
  });
}

/**
 *开奖
 */
function prizeDrawOpen(params) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/config/open',
    method: 'GET',
    params: params
  });
}

/**
 *列表分页
 */
function prizeDrawNewList(data) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/list',
    method: 'post',
    data: data
  });
}

/**
 *更新中奖结果
 */
function prizeDrawNewUpdate(data) {
  return (0, _request.default)({
    url: '/admin/prizeDraw/update',
    method: 'post',
    data: data
  });
}

/**
 * 小程序列表自动补全
 */
function companyappAutoListApi(params) {
  // return request({
  //     url: `/admin/companyapp/autoList`,
  //     method: 'GET',
  //     params,
  // })
  return requestMapi({
    url: '/mapi/user/admin/company-app/autoList',
    method: 'get',
    params: params
  });
}